import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  AddFieldDefs,
  DeleteBuilderForm,
  DeleteBuilderReport,
  DeleteBuilderActions,
  EditBuilderActions,
  LoadBuilderDatasets,
  LoadBuilderFastReports,
  LoadBuilderFastReport,
  LoadBuilderForms,
  LoadBuilderMenus,
  LoadBuilderPropEditor,
  LoadBuilderReports,
  LoadBuilderThemas,
  LoadBuilderWidgets,
  LoadBuilderWizards,
  LoadNavigationTree,
  NewBuilderForm,
  SaveCurrentEditTree,
  SetBuilderActions,
  SetBuilderCanvas,
  SetBuilderDataset,
  SetBuilderObjectState,
  SetBuilderProperty,
  SetBuilderWizard,
  SetComponentEditState,
  SetDeviceProperties,
  SetDeviceResolution,
  SetDeviceType,
  SetEventHandler,
  SetScaleValue,
  SetSplitterProperty,
  UpdateDataset,
  ClearFieldDefs,
  NewBuilderWizard,
  NewBuilderReport,
  NewBuilderMenu,
  ClearBuilderActions,
  UpdateComponentName,
  DeleteBuilderMenu,
  DeleteBuilderWizard,
  UpdateFormFromBackend,
} from './isformbuilder.action';
import { filter, take, tap } from 'rxjs/operators';
import {
  IIsComponent,
  LoadComponent,
  UnLoadComponent,
  Outlet2Service,
  ComponentsService,
} from '@ic-builder/is-base';
import { IsCloudService } from '@ic-builder/data-access-iscloud';
import { UpdateWidgetPath } from './form-definition.actions';
import { AnyArray } from 'immer/dist/internal';

interface BuilderProperty {
  id: number;
  name: string;
  value?: unknown;
  children?: Array<BuilderProperty>;
}

export interface IsFormBuilderStateModel {
  unimonitor: boolean;
  builderwidgets: any;
  builderforms: Array<any>;
  builderreports: any;
  builderfastreports: any;
  builderfastreport: any;
  buildermenus: any;
  buildermenuslist: string;
  builderformlist: string;
  builderdatasets: any;
  builderwizards: any;
  builderwizardlist: string;
  //buildercanvasform: any;
  builderpropertycomp: IIsComponent;
  builderthemas: any;
  builderthemalist: string;
  builderpropeditorforms: any;
  builderpropeditorformslist: string;
  navigationtree: any;
  builderproperties: Array<BuilderProperty>;
  builderactions: any;
  builderqueryfielddefs: any;
  builderdataset: any;
  builderrunresult: any;
  builder: boolean;
  builderdevicetype: string;
  builderdeviceresolution: string;
  builderdeviceheight: string;
  builderdevicewidth: string;
  buildersplitterproperty: boolean;
  builderscalevalue: number;
  builderobjectstate: any;
}

@State<IsFormBuilderStateModel>({
  name: 'isformbuilderstate',
  defaults: {
    unimonitor: false,
    builderwidgets: null,
    builderforms: null,
    builderreports: null,
    builderfastreports: null,
    builderfastreport: null,
    buildermenus: null,
    buildermenuslist: null,
    builderformlist: null,
    builderdatasets: null,
    builderwizards: null,
    builderwizardlist: null,
    //buildercanvasform: null,
    builderpropertycomp: null,
    builderthemas: null,
    builderthemalist: null,
    builderpropeditorforms: null,
    builderpropeditorformslist: null,
    navigationtree: null,
    builderproperties: null,
    builderactions: null,
    builderqueryfielddefs: [],
    builderdataset: null,
    builderrunresult: null,
    builder: false,
    builderdevicetype: 'desktop',
    builderdeviceresolution: 'default',
    builderdeviceheight: undefined,
    builderdevicewidth: undefined,
    buildersplitterproperty: false,
    builderscalevalue: 1,
    builderobjectstate: null,
  },
})
@Injectable()
export class IsFormBuilderState {
  teller: number;
  editform = 'isform';
  version = 1;

  constructor(private ic: IsCloudService, private store: Store, private comp:ComponentsService) {    
    // const subregistred = this.store.select(state => state['iscloudstate'].registered);
    // subregistred.subscribe((item) => {
    //    if (item){
    //     this.store.dispatch({"type":"[WSIC] SubscribeChannel","payload":{channelname:"FORMS",canbeusedindesigner:true}})
    //    }
    // });  

    // this.store.dispatch({"type":"[IsConnectWebSocket]","payload":{deviceid:1,accountid:10,useindesigner:true}});
  }

  @Selector()
  public static builderobjectstate(state: IsFormBuilderStateModel) {
    return state.builderobjectstate;
  }

  @Selector()
  public static builderwidgets(state: IsFormBuilderStateModel) {
    return state.builderwidgets;
  }

  @Selector()
  public static builderforms(state: IsFormBuilderStateModel) {
    return state.builderforms;
  }

  @Selector()
  public static builderreports(state: IsFormBuilderStateModel) {
    return state.builderreports;
  }

  @Selector()
  public static builderfastreports(state: IsFormBuilderStateModel) {
    return state.builderfastreports;
  }

  @Selector()
  public static builderfastreport(state: IsFormBuilderStateModel) {
    return state.builderfastreport;
  }

  @Selector()
  public static builderdatasets(state: IsFormBuilderStateModel) {
    return state.builderdatasets;
  }

  @Selector()
  public static builderwizards(state: IsFormBuilderStateModel) {
    return state.builderwizards;
  }

  @Selector()
  public static builderthemas(state: IsFormBuilderStateModel) {
    return state.builderthemas;
  }

  @Selector()
  public static buildermenus(state: IsFormBuilderStateModel) {
    return state.buildermenus;
  }

  @Selector()
  public static builderpropeditorforms(state: IsFormBuilderStateModel) {
    return state.builderpropeditorforms;
  }

  @Selector()
  public static navigationtree(state: IsFormBuilderStateModel) {
    return state.navigationtree;
  }

  @Selector()
  public static builderproperties(state: IsFormBuilderStateModel) {
    return state.builderproperties;
  }

  @Selector()
  public static builderactions(state: IsFormBuilderStateModel) {
    return state.builderactions;
  }

  @Selector()
  public static builderqueryfielddefs(state: IsFormBuilderStateModel) {
    return state.builderqueryfielddefs;
  }

  @Selector()
  public static builderdataset(state: IsFormBuilderStateModel) {
    return state.builderdataset;
  }

  @Selector()
  public static builderrunresult(state: IsFormBuilderStateModel) {
    return state.builderrunresult;
  }

  @Selector()
  public static builderdevicetype(state: IsFormBuilderStateModel) {
    return state.builderdevicetype;
  }

  @Selector()
  public static builderdeviceresolution(state: IsFormBuilderStateModel) {
    return state.builderdeviceresolution;
  }

  @Selector()
  public static builderdeviceheight(state: IsFormBuilderStateModel) {
    return state.builderdeviceheight;
  }

  @Selector()
  public static builderdevicewidth(state: IsFormBuilderStateModel) {
    return state.builderdevicewidth;
  }

  @Selector()
  public static buildersplitterproperty(state: IsFormBuilderStateModel) {
    return state.buildersplitterproperty;
  }

  @Selector()
  public static builderscalevalue(state: IsFormBuilderStateModel) {
    return state.builderscalevalue;
  }

  datakey(action: string): string {
    const now = new Date();
    return (
      action +
      '.loaddata' +
      now.getFullYear() +
      now.getMonth() +
      now.getDay() +
      '_' +
      now.getHours() +
      now.getMinutes() +
      now.getSeconds() +
      now.getMilliseconds()
    );
  }

  @Action(UpdateFormFromBackend)
  updateformfromBackend({ getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: UpdateFormFromBackend ) 
  {
     console.log(payload);
     const state = getState();

     const componentTree = JSON.parse(payload.Form);

     const refreshlist = [];
     refreshlist.push(new UnLoadComponent(payload.id));
     refreshlist.push(
       new LoadComponent({
         id: componentTree[0].parentid,
         refresh: 1,
         name: 'canvasbuilder',
         outlet: -10000,
         loadas: 1_000_000,
         source: componentTree,
         data: componentTree[0]
       }));
     // dispatch(this.commandlist);
     this.store.dispatch(refreshlist);

  }    
    
  @Action(UpdateComponentName)
     updatecomponentName(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: UpdateComponentName
  ) {
    const state = getState();
    const builderforms = state.builderforms;
    const idx = builderforms.findIndex((item) => {
      return item.id == payload.id;
    });
    if (idx > -1) {
      builderforms[idx].name = payload.name;
    }
    patchState({
      builderforms: builderforms,
    });
  }

  removeBackTicks(s:string):string {
    return s?s.replace(/^\`|`+$/g,''):s;          
  }

  @Action(LoadBuilderWidgets)
  loadBuilderWidgets(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderWidgets
  ) {
    const state = getState();
    //console.log(`%cClass: IsFormBuilderState, Function: loadBuilderWidgets(payload): `, 'color: green;', payload);

    if (payload) {
      if (!state.builderwidgets) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            account: 10,
            cached: false,
            language: 'nl',
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((widgets) => {
              //let data = JSON.parse(widgets);
              if (Array.isArray(widgets)) {
                widgets.forEach((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      //console.log('widget children', a);
                      try {
                        //if (a.config) {
                        a.config = JSON.parse(this.removeBackTicks(a.config));
                        //}

                        if (a.attribs) {
                          a.attribs = JSON.parse(this.removeBackTicks(a.attribs));
                        }

                        if (a.builder) {
                          a.builder = JSON.parse(this.removeBackTicks(a.builder));
                        }
                      } catch (Error) {
                        console.error(
                          'error json load builder widgets ',
                          Error,
                          ' ',
                          a
                        );
                      }
                    });
                  }
                });
                patchState({
                  builderwidgets: widgets,
                });
              } else {
                console.log(
                  `%cUnexpected value in Class: IsFormBuilderState, Function: LoadBuilderWidgets(widgets): `,
                  'color: black;',
                  widgets
                );
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderForms)
  loadBuilderForms(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderForms
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderforms) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            cached: false,
            account: 10,
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderforms) => {
              //let data = JSON.parse(widgets);
              if (builderforms) {
                builderforms.forEach((w) => {
                  if (w.children) {
                    w.children.forEach((a) => {
                      a.config = JSON.parse(a.config);
                      // a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderforms: builderforms,
                  builderformlist: payload,
                });
              }
            })
          );
      }
    }
  }

  @Action(DeleteBuilderForm)
  deleteBuilderForm(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: DeleteBuilderForm
  ) {
    const state = getState();

    if (payload) {
      if (state.builderforms) {
        const builderforms = state.builderforms;
        const idx = builderforms.findIndex((a) => {
          return a.id == payload.id;
        });
        if (idx > -1) {
          builderforms.splice(idx, 1);
          patchState({
            builderforms: [...builderforms],
          });
        }
      }
    }
  }

  @Action(DeleteBuilderWizard)
  deleteBuilderWizard(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: DeleteBuilderWizard
  ) {
    const state = getState();

    if (payload) {
      if (state.builderwizards) {
        const builderwizards = state.builderwizards;
        const idx = builderwizards.findIndex((a) => {
          return a.id == payload.id;
        });
        if (idx > -1) {
          builderwizards.splice(idx, 1);
          patchState({
            builderwizards: [...builderwizards],
          });
        }
      }
    }
  }

  @Action(DeleteBuilderMenu)
  deleteBuilderMenus(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: DeleteBuilderMenu
  ) {
    const state = getState();

    if (payload) {
      if (state.buildermenus) {
        const buildermenus = state.buildermenus;
        const idx = buildermenus.findIndex((a) => {
          return a.id == payload.id;
        });
        if (idx > -1) {
          buildermenus.splice(idx, 1);
          patchState({
            buildermenus: [...buildermenus],
          });
        }
      }
    }
  }

  @Action(NewBuilderReport)
  newBuilderReport(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: NewBuilderReport
  ) {
    const state = getState();

    if (payload) {
      if (state.builderreports) {
        const idx = [...state.builderreports].findIndex((d) => {
          return d.parentid == payload.parentid;
        });
        if (idx == -1) {
          patchState({
            builderreports: [...state.builderreports, payload],
          });
        }
      }
    }
  }

  @Action(NewBuilderWizard)
  newBuilderWizard(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: NewBuilderWizard
  ) {
    const state = getState();

    if (payload) {
      if (state.builderwizards) {
        const idx = [...state.builderwizards].findIndex((d) => {
          return d.parentid == payload.parentid;
        });
        if (idx == -1) {
          patchState({
            builderwizards: [...state.builderwizards, payload],
          });
        }
      }
    }
  }

  @Action(NewBuilderForm)
  newBuilderForm(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: NewBuilderForm
  ) {
    const state = getState();

    if (payload) {
      if (state.builderforms) {
        const idx = [...state.builderforms].findIndex((d) => {
          return d.parentid == payload.parentid;
        });
        if (idx == -1) {
          patchState({
            builderforms: [...state.builderforms, payload],
          });
        }
      }
    }
  }

  @Action(NewBuilderMenu)
  newBuilderMenu(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: NewBuilderMenu
  ) {
    const state = getState();

    if (payload) {
      if (state.buildermenus) {
        const idx = [...state.buildermenus].findIndex((d) => {
          return d.parentid == payload.parentid;
        });
        if (idx == -1) {
          patchState({
            buildermenus: [...state.buildermenus, payload],
          });
        }
      }
    }
  }

  @Action(SetBuilderObjectState)
  setBuilderObjectState(
    { patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderObjectState
  ) {
    if (payload) {
      patchState({
        builderobjectstate: payload,
      });
    }
  }

  @Action(LoadBuilderReports)
  loadBuilderFormsReports(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderReports
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderreports) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            cached: false,
            account: 10,
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderreports) => {
              //let data = JSON.parse(widgets);
              if (builderreports) {
                builderreports.map((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      a.config = JSON.parse(a.config);
                      a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderreports: builderreports,
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderFastReports)
  loadBuilderFormsFastReports(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderFastReports
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderfastreports) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            account: 10,
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderfastreports) => {
              //let data = JSON.parse(widgets);
              if (builderfastreports) {
                patchState({
                  builderfastreports: builderfastreports,
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderFastReport)
  loadBuilderFormsFastReport(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderFastReport
  ) {
    const state = getState();

    if (payload) {
      return this.ic
        .getData('loadfastreport', {
          id: payload,
          role: '1',
          language: 'nl',
          account: 10,
          logging: { unimonitor: state.unimonitor },
        })
        .pipe(
          tap((builderfastreport) => {
            //let data = JSON.parse(widgets);
            if (builderfastreport) {
              patchState({
                builderfastreport: builderfastreport[0],
              });
            }
          })
        );
    }
  }

  @Action(DeleteBuilderReport)
  deleteBuilderReport(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: DeleteBuilderReport
  ) {
    const state = getState();

    if (payload) {
      if (state.builderreports) {
        const builderreports = state.builderreports;
        const idx = builderreports.findIndex((a) => {
          return a.id == payload.id;
        });
        if (idx > -1) {
          builderreports.splice(idx, 1);
          patchState({
            builderforms: [...builderreports],
          });
        }
      }
    }
  }

  @Action(LoadBuilderMenus)
  loadBuilderFormsMenus(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderMenus
  ) {
    const state = getState();

    if (payload) {
      if (!state.buildermenus) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            cached: false,
            account: 10,
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((buildermenus) => {
              //let data = JSON.parse(widgets);
              if (buildermenus) {
                buildermenus.map((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      a.config = JSON.parse(a.config);
                      a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  buildermenus: buildermenus,
                  buildermenuslist: payload
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderThemas)
  loadBuilderThemas(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderThemas
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderthemas) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderthemas) => {
              //let data = JSON.parse(widgets);
              if (builderthemas) {
                builderthemas.map((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      a.config = JSON.parse(a.config);
                      a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderthemas: builderthemas,
                  //builderformlist:payload
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderPropEditor)
  loadBuilderPropEditor(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderPropEditor
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderpropeditorforms) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderpropeditorforms) => {
              //let data = JSON.parse(widgets);
              if (builderpropeditorforms) {
                builderpropeditorforms.map((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      a.config = JSON.parse(a.config);
                      a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderpropeditorforms: builderpropeditorforms,
                  //builderformlist:payload
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderDatasets)
  loadBuilderDatasets(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderDatasets
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderdatasets) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderdatasets) => {
              //let data = JSON.parse(widgets);
              if (builderdatasets) {
                builderdatasets.map((w) => {
                  if (w.children) {
                    w.children.map((a) => {
                      a.config = JSON.parse(a.config);
                      a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderdatasets: builderdatasets,
                });
              }
            })
          );
      }
    }
  }

  @Action(LoadBuilderWizards)
  loadBuilderWizards(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadBuilderWizards
  ) {
    const state = getState();

    if (payload) {
      if (!state.builderwizards) {
        return this.ic
          .getData(payload, {
            name: payload,
            role: '1',
            language: 'nl',
            cached: false,
            account: 10,
            logging: { unimonitor: state.unimonitor },
          })
          .pipe(
            tap((builderwizards) => {
              //let data = JSON.parse(widgets);
              if (builderwizards) {
                builderwizards.forEach((w) => {
                  if (w.children) {
                    w.children.forEach((a) => {
                      a.config = JSON.parse(a.config);
                      // a.place = JSON.parse(a.place);
                    });
                  }
                });
                patchState({
                  builderwizards: builderwizards,
                  builderwizardlist: payload,
                });
              }
            })
          );
      }
    }

    // if (payload) {
    //   if (!state.builderwizards) {
    //     return this.ic
    //       .getData(payload, {
    //         name: payload,
    //         role: '1',
    //         language: 'nl',
    //         logging: { unimonitor: state.unimonitor },
    //       })
    //       .pipe(
    //         tap((builderwizards) => {
    //           //let data = JSON.parse(widgets);
    //           if (builderwizards) {
    //             builderwizards.map((w) => {
    //               if (w.children) {
    //                 w.children.map((a) => {
    //                   a.config = JSON.parse(a.config);
    //                   a.place = JSON.parse(a.place);
    //                 });
    //               }
    //             });
    //             patchState({
    //               builderwizards: builderwizards,
    //             });
    //           }
    //         })
    //       );
    //   }
    // }
  }

  convertjson(obj: IIsComponent) {
    try {
      if (obj.config) {
        obj.config = JSON.parse(obj.config);
      }
      if (obj.attribs) {
        obj.attribs = JSON.parse(obj.attribs);
      }
      if (obj.children) {
        (obj.children as Array<any>).map((a) => {
          this.convertjson(a);
        });
      }
    } catch {
      console.error('Error parsing json ', obj);
    }
    return obj;
  }

  @Action(LoadNavigationTree)
  loadNavigationTree(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: LoadNavigationTree
  ) {
    const state = getState();

    if (payload) {
      if (!state.navigationtree) {
        //this.store.dispatch(new LoadForm({id:0,name:'navigationtree',outlet:null,loadas:1000000}))

        return this.ic
          .getData(payload, { name: payload, id: 0, role: '1', language: 'nl' })
          .pipe(
            tap((tree) => {
              //let data = JSON.parse(widgets);
              if (tree) {
                tree.map((a) => {
                  a = this.convertjson(a);
                });
                patchState({
                  navigationtree: tree,
                });
              }
            })
          );
      }
    }
  }

  objecttoproparray(config: IIsComponent): Array<BuilderProperty> {
    return Object.entries(config)
      .filter(
        ([k, v]) =>
          ![
            'attribs',
            'children',
            'self',
            'formgroupdef',
            'headerCompref',
            'columnCompref',
            'parentCompref',
          ].includes(k) && typeof v !== 'function'
      )
      .map(([key, value]) =>
        typeof value === 'object' && value !== null
          ? {
              id: this.teller++,
              name: key,
              children: this.objecttoproparray(value),
            }
          : { id: this.teller++, name: key, value }
      );
  }

  // objecttoproparray(config, proparray) {
  //   // console.group('Nested objecttoproparray');
  //   // console.log(`%cClass: IsFormBuilderState, Function: objecttoproparray(config): `, 'color: green;', config);
  //   const data = [];
  //   for (const [key, value] of Object.entries(config).filter(
  //     ([k, v]) => !['self', 'formgroupdef'].includes(k) && v && typeof value !== 'function'
  //   )) {
  //     if (value && key !== 'events') {
  //       if (typeof value === 'object') {
  //         {
  //           const prop: any = { id: this.teller++, name: key };
  //           prop.children = [];
  //           if (key !== 'self' && typeof value !== 'function') {
  //             this.objecttoproparray(value, prop.children);
  //           } else {
  //             //prop['type'] = value;
  //           }
  //           proparray.push(prop);
  //         }
  //       } else {
  //         proparray.push({ id: this.teller++, name: key, value: value });
  //       }
  //     } else {
  //       proparray.push({ id: this.teller++, name: key, value: value });
  //     }
  //   }
  //   // console.groupEnd();
  //   return data;
  // }

  objecttoeventarray(config) {
    const data = [];
    for (const [key, value] of Object.entries(config)) {
      if (typeof value === 'object') {
        data.push(value);
      }
    }
    return data;
  }

  @Action(SetBuilderCanvas)
  setBuilderCanvas(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderCanvas
  ) {
    if (payload == null) {
      return;
    }
    //console.log(`%cClass: IsFormBuilderState, Function: setBuilderCanvas(payload): `, 'color: black;', payload);
    if (typeof payload === 'number') {
      this.store.dispatch(
        new LoadComponent({
          id: payload,
          name: 'canvasbuilder',
          outlet: -10000,
          loadas: 1000000,
        })
      );
    } else {
      this.store.dispatch(
        new LoadComponent({
          id: payload.id,
          comptype: payload.comptype,
          name: 'canvasbuilder',
          outlet: -10000,
          loadas: 1000000,
        })
      );
    }
  }

  @Action(SetComponentEditState)
  setComponentEditState(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetComponentEditState
  ) {
    const state = getState();
    const formIdx = state.builderforms.findIndex(
      (node) => node.id === payload.id
    );
    const formsArray = [...state.builderforms];
    const originalForm = state.builderforms[formIdx];
    const updatedForm = {
      ...originalForm,
      state: payload.state,
    };
    formsArray.splice(formIdx, 1, updatedForm);
    patchState({
      builderforms: formsArray,
    });
  }

  @Action(SetBuilderWizard)
  setBuilderWizard(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderWizard
  ) {
    const state = getState();
    this.store.dispatch(
      new LoadComponent({
        id: payload,
        name: 'canvasbuilder',
        outlet: -10000,
        loadas: 1000000,
      })
    );
  }

  @Action(SetBuilderActions)
  setBuilderActions(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderActions
  ) {
    const state = getState();

    this.teller = 1;
    let actions: any = [];
    if (payload) {
      actions = this.objecttoeventarray(payload.events);
    }
    patchState({
      builderactions: actions,
    });
  }

  @Action(EditBuilderActions)
  editBuilderActions(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: EditBuilderActions
  ) {
    const state = getState();
    const builderactions = state.builderactions;

    const id = Number(payload.id);

    const idx = builderactions.findIndex((act) => act.id == id);

    let newActions;

    // console.log(
    //   `%cClass: IsFormBuilderState, Function: editBuilderActions(idx, payload): `,
    //   'color: black;',
    //   idx,
    //   payload
    // );

    if (idx == -1) {
      newActions = [...builderactions, payload];
    } else {
      newActions = [...builderactions];
      newActions.splice(idx, 1, payload);
    }

    //this.teller = 1;
    //let actions: any = [];
    //if (payload) {
    //  this.objecttoeventarray(payload, actions);
    //}
    patchState({
      builderactions: newActions,
    });
    this.store.dispatch(
      new SetEventHandler({
        events: newActions,
        formid: 1000000,
        compid: payload.parentid,
      })
    );
    this.store.dispatch(
      new UpdateWidgetPath({
        id: payload.parentid,
        path: ['events'],
        value: newActions,
      })
    );
  }

  @Action(DeleteBuilderActions)
  deleteBuilderAction(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: DeleteBuilderActions
  ) {
    let { builderactions } = getState();

    if (payload.eventid > 0) {
      console.log('delete at server');
    }
    builderactions = builderactions.filter((b) => b.id !== payload.eventid);
    patchState({
      builderactions: builderactions,
    });
    this.store.dispatch(
      new SetEventHandler({
        events: builderactions,
        formid: 1000000,
        compid: payload.compid,
      })
    );
    this.store.dispatch(
      new UpdateWidgetPath({
        id: payload.compid,
        path: ['events'],
        value: builderactions,
      })
    );
  }

  @Action(SetBuilderProperty)
  setBuilderProperty(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderProperty
  ) {
    this.teller = 1;
    let property: any = [];
    if (payload) {
      //console.log(`%cClass: IsFormBuilderState, Function: setBuilderProperty(payload): `, 'color: blue;', payload);
      //console.dir(payload);
      // this.objecttoproparray(payload, property);
      property = this.objecttoproparray(payload);
    }

    let actions: any = [];

    if (payload?.events) {
      actions = this.objecttoeventarray(payload.events);
    }

    patchState({
      builderproperties: property,
      builderpropertycomp: payload,
      builderactions: actions,
    });
  }

  @Action(SetBuilderDataset)
  setBuilderDataset(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetBuilderDataset
  ) {
    const state = getState();
    let temp = state.builderdataset;
    temp = Object.assign({}, payload);
    patchState({
      builderdataset: temp,
    });
  }

  @Action(UpdateDataset)
  updateDataset(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: UpdateDataset
  ) {
    const state = getState();
    const temp = state.builderdatasets;
    if (temp) {
      const idx = temp.find((set) => {
        set.id === payload.id;
      });
      temp[idx] = payload;
    }
    patchState({
      builderdatasets: temp,
    });
  }

  @Action(SaveCurrentEditTree)
  saveCurrentEditTree({
    getState,
    patchState,
  }: StateContext<IsFormBuilderStateModel>) {
    const state = getState();
    patchState({ builderforms: null });
    this.store.dispatch(new LoadBuilderForms(state.builderformlist));
  }

  @Action(SetDeviceType)
  setDeviceType(
    { patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetDeviceType
  ) {
    patchState({ builderdevicetype: payload });
  }

  @Action(SetDeviceResolution)
  setDeviceResolution(
    { patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetDeviceResolution
  ) {
    patchState({ builderdeviceresolution: payload });
  }

  @Action(SetDeviceProperties)
  setDeviceProperties(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetDeviceProperties
  ) {
    const state = getState();
    if (payload.height && payload.width) {
      patchState({
        builderdevicetype: payload.devicepicker,
        builderdeviceresolution: payload.resolution,
        builderdeviceheight: payload.height,
        builderdevicewidth: payload.width,
      });
    } else {
      patchState({
        builderdevicetype: payload.devicepicker,
        builderdeviceresolution: payload.resolution,
        builderdeviceheight: state.builderdeviceheight,
        builderdevicewidth: state.builderdevicewidth,
      });
    }
  }

  @Action(SetSplitterProperty)
  setSplitterProperty(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetSplitterProperty
  ) {
    patchState({
      buildersplitterproperty: payload,
    });
  }

  @Action(SetScaleValue)
  setScaleValue(
    { patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: SetScaleValue
  ) {
    patchState({
      builderscalevalue: payload,
    });
  }

  @Action(AddFieldDefs)
  addFielddefs(
    { getState, patchState }: StateContext<IsFormBuilderStateModel>,
    { payload }: AddFieldDefs
  ) {
    const state = getState();
    const parent = {
      name: payload.name,
      children: payload.children.map((child) => {
        return { ...child, id: this.teller++ };
      }),
      id: this.teller++,
    };
    const idx = [...state.builderqueryfielddefs].findIndex((d) => {
      return d.name == payload.name;
    });
    if (idx == -1) {
      patchState({
        builderqueryfielddefs: [...state.builderqueryfielddefs, parent],
      });
    }
  }

  @Action(ClearFieldDefs)
  clearFieldDefs({ patchState }: StateContext<IsFormBuilderStateModel>) {
    patchState({
      builderqueryfielddefs: [],
    });
  }

  @Action(ClearBuilderActions)
  clearBuilderActions({ patchState }: StateContext<IsFormBuilderStateModel>) {
    patchState({
      builderactions: [],
    });
  }

  // @Action(LoadFormInEditor)
  // loadFormInEditor({ payload }: LoadFormInEditor) {
  //   this.builderservice.outletserv().editid = payload.id;
  //   // node.data.state = 1;

  //   this.builderservice.canvasmode = 1;
  //   this.builderservice
  //     .outletserv()
  //     .getComponentById$(1_000_000)
  //     .pipe(
  //       filter((iic) => iic?.id === payload.id),
  //       take(1)
  //     )
  //     .subscribe((s) => {
  //       this.store.dispatch({ type: '[SetCurrentFormDefinition]', payload: s });
  //     });

  //   //this.store.dispatch(new SetComponentEditState({ id: data.id, state: 1 }));
  //   this.store.dispatch(new SetBuilderCanvas(payload.parentid));
  // }

  // @Action(LoadMenuInEditor)
  // loadMenuInEditor({ payload }: LoadMenuInEditor) {
  //   this.builderservice.outletserv().editid = payload.id;
  //   // node.data.state = 1;

  //   this.builderservice.canvasmode = 2;
  //   this.builderservice
  //     .outletserv()
  //     .getComponentById$(1_000_000)
  //     .pipe(
  //       filter((iic) => iic?.id === payload.id),
  //       take(1)
  //     )
  //     .subscribe((s) => {
  //       this.store.dispatch({ type: '[SetCurrentFormDefinition]', payload: s });
  //     });

  //   //this.store.dispatch(new SetComponentEditState({ id: data.id, state: 1 }));
  //   this.store.dispatch(new SetBuilderCanvas(payload.parentid));
  // }
}
